import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";

/* eslint-disable import/no-mutable-exports, global-require */
var fetch;

if (__CLIENT__) {
  require('whatwg-fetch');

  fetch = window.fetch.bind(window);
} else {
  fetch = require('node-fetch').default;
}

export default fetch;